var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 6.25H4.25V5.75H10.0938H10.6973L10.2705 5.32322L9.30668 4.35938L9.67188 3.99418L11.4931 5.81545L11.6697 6L11.4931 6.18455L9.67188 8.00582L9.30668 7.64062L10.2705 6.67678L10.6973 6.25H10.0938ZM0.25 6C0.25 2.82948 2.82948 0.25 6 0.25C7.85157 0.25 9.50231 1.12704 10.5542 2.49057L10.1485 2.7792C9.18744 1.54503 7.68981 0.75 6 0.75C3.09435 0.75 0.75 3.09435 0.75 6C0.75 8.90565 3.09435 11.25 6 11.25C7.68953 11.25 9.18897 10.4552 10.1487 9.22092L10.5542 9.50943C9.50231 10.873 7.85157 11.75 6 11.75C2.82948 11.75 0.25 9.17052 0.25 6Z",
    stroke: "#222222",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.313507a7.svg";
export { ForwardRef as ReactComponent };